import React from "react";

import List, { ListItem } from "components/List";
import { BlockWrapper } from "components/Block";

import { Heading, Block } from "components/Block/ContentBlock/styles";

import { Image } from "./styles";

const Resources = ({ content }) => {
  return (
    <BlockWrapper pt={["30px", "50px", "100px"]} pb="20px" alignItems="center">
      <Block width={["100%", "100%", "40%"]}>
        <Image content={content.image} />
      </Block>
      <Block px={["0", "10px", "20px"]} width={["100%", "100%", "60%"]}>
        <Heading textAlign={["center", "center", "left"]}>
          {content.heading}
        </Heading>
        <List mb="0">
          {content.items.map((item, index) => (
            <ListItem key={index} content={item} />
          ))}
        </List>
      </Block>
    </BlockWrapper>
  );
};

export default Resources;
